import styled from 'styled-components'
import { AdvantagesElement } from 'Pages/landings/newLandings/common/components'
import { WrapperBlock, media, Breakpoints } from 'Pages/landings/newLandings/common/style'

export const Wrapper = styled(WrapperBlock)`
	column-gap: 32px;
	display: grid;
	row-gap: 32px;
	justify-content: space-between;
	${media('grid: repeat(3, 1fr) / 1fr;', Breakpoints.lx)};
	${media('grid: repeat(3, 1fr) / 1fr;', Breakpoints.xl)};
	${media('grid: 1fr / repeat(3, 1fr);', Breakpoints.ms)};
`

export const Element = styled(AdvantagesElement)`
	margin: 0;
	padding: 0;
`
